import { graphql } from "@/lib/gql/__generated__/gql";

export const DummyRoomCreateMutation = graphql(/* GraphQL */ `
	mutation DummyRoomCreate($input: RoomDummyInput!) {
		roomDummyCreate(input: $input) {
			userErrors
			roomDummy {
				id
				hotelID
				roomID
				inSale
				maxRoomNum
				capacityPeopleMaximum
				capacityAdultMaximum
				capacityKidsMaximum
				isKidsUnavailable
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				name
				catchCopy
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
